import React from "react";
import style from "./Header.module.css";
import NavBar from "./Navbar/Navbar";
import HeaderBody from "./HeaderBody/HeaderBody";

const Header = () => {
  return (
    <div className={style.header}>
      <NavBar />
      <HeaderBody />
    </div>
  );
};

export default Header;
